var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fade-in"},[_c('div',{staticClass:"container ml2"},[_c('h1',{staticClass:"title"},[_vm._v("Error")]),_vm._v("\n    An error occurred. "+_vm._s(_vm.active)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }